// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3n0Lm","options":"AnswerScale_options__1jAXP","selected":"AnswerScale_selected__3Y0Ux"};